// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__+01rZ"};